var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { observer } from "mobx-react";
import { Renderer } from "./Renderer";
import { defineCustomTags } from "sb-helpers";
defineCustomTags("sb-lazy-render");
let LazyRender = class LazyRender extends React.Component {
    constructor(props) {
        super(props);
        this.refRoot = React.createRef();
        this.state = {
            renderer: new Renderer(this.props.observerOptions || {})
        };
    }
    componentWillUnmount() {
        if (this.refRoot.current) {
            this.state.renderer.unRegisterDom(this.refRoot.current);
        }
    }
    componentDidMount() {
        if (this.refRoot.current) {
            this.state.renderer.registerDom(this.refRoot.current);
        }
    }
    render() {
        // TODO: improve the render method to lower complexity and increase coverage
        let children = this.props.children;
        if (typeof this.props.contentCallback === "function" &&
            this.state.renderer.isVisible) {
            children = this.props.contentCallback();
        }
        return (React.createElement("sb-lazy-render", { style: { minHeight: this.props.baseMinHeight }, ref: this.refRoot }, this.state.renderer.isVisible && children));
    }
};
LazyRender = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], LazyRender);
export { LazyRender };
//# sourceMappingURL=LazyRender.js.map